<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết vị trí thiết bị</h1>
      <div>
        <div class="btn-group">
          <button
            @click="$router.push('/device-location/list')"
            class="f12 font-medium btn btn-outline-secondary"
          >
            <i class="bx bx-left-arrow-alt"></i> Quay lại
          </button>
          <button
            v-if="canUpdate()"
            @click="
              openFormDevice('Sửa thông tin thiết bị', {
                item,
                type: 'device',
                isEdit: true,
              })
            "
            class="f12 font-medium btn btn-outline-secondary"
          >
            Sửa thông tin thiết bị
          </button>
          <button
            v-if="canUpdate()"
            @click="
              openFormDevice('Sửa thông tin MC', {
                item,
                type: 'mc',
                isEdit: true,
              })
            "
            class="f12 font-medium btn btn-outline-secondary"
          >
            Sửa thông tin MC
          </button>
          <button
            v-if="canUpdate()"
            @click="
              openFormDevice('Sửa thông tin DCNTT', {
                item,
                type: 'area',
                isEdit: true,
              })
            "
            class="f12 font-medium btn btn-outline-secondary"
          >
            Sửa thông tin DCNTT
          </button>
          <button
            v-if="canLock(item)"
            @click="lock(item, true)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Khoá
          </button>
          <button
            v-if="canUnLock(item)"
            @click="lock(item, false)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Mở khoá
          </button>
          <button
            v-if="canVerify(item)"
            @click="verify(item, true)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Xác thực
          </button>
          <button
            v-if="canUnVerify(item)"
            @click="verify(item, false)"
            class="f12 font-medium btn btn-outline-secondary"
          >
            Bỏ xác thực
          </button>
        </div>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <Card title="Thiết bị">
            <Content title="Loại thiết bị">
              {{ item.deviceType | transformData(deviceTypeOptions) }}
            </Content>
            <Content title="Serial" :content="item.serial" />
            <Content title="Loại PL/BB">
              {{ item.typeAppendix | transformData(typeAppendixOptions) }}
            </Content>
            <Content title="Trạng thái">
              <Status :value="item.status" :config="statusOptions" />
            </Content>
            <Content title="Tình trạng xác thực">
              <Status :value="item.verify" :config="verifyOptions" />
            </Content>
            <Content title="Thời gian xác thực">
              {{ item.verifyDate ? new Date(item.verifyDate).toLocaleString() : 'N/A' }}
            </Content>
            <Content title="Người xác thực">
              {{ item.verifyByEmail || 'N/A' }}
            </Content>
          </Card>
          <Card title="ĐCNTT">
            <Content title="Tên ĐCNTT" :content="item.areaName" />
            <Content title="Địa chỉ">
              {{ item.areaAddress }} - {{ item.areaDistrict }} -
              {{ item.areaCity }}
            </Content>
          </Card>
          <Card title="Merchant">
            <Content title="Tên merchant" :content="item.merchantName" />
            <Content title="Email" :content="item.email" />
            <Content title="SĐT" :content="item.mobile" />
            <Content title="Địa chỉ" :content="item.address" />
            <Content title="Sale phụ trách">
              {{ item.activeSaleName }} - {{ item.activeSaleEmail }}
            </Content>
          </Card>
        </div>
        <div class="col-sm-6 mb-3">
          <Card title="Lịch sử">
            <div class="table-responsive text-center p-0">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col"><b>Người thực hiện</b></th>
                    <th scope="col"><b>Hành động</b></th>
                    <th scope="col"><b>Thời gian</b></th>
                    <th scope="col"><b>Chi tiết</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(data, index) in history" :key="index">
                    <td class="text-center">{{ data.createByName }} - {{ data.createByEmail }}</td>
                    <td class="text-center">
                      {{ data.action | transformData(Config.deviceLocationHistoryAction) }}
                    </td>
                    <td class="text-center">
                      {{ data.createAt | formatDate('HH:mm, DD/MM/YYYY') }}
                    </td>
                    <td class="text-center detail">
                      <p class="w-full text-center" @click="viewDetailHistory(data.id)">Chi tiết</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import DetailChange from './_detail_change.vue'
  import { MerchantService } from '@/services/merchant.service'
  import mxItemAction from './mx-item-action.js'
  export default {
    mixins: [mxItemAction],
    data() {
      return {
        item: {},
        history: [],
        showLoading: false,
      }
    },
    async created() {
      try {
        this.showLoading = true
        await this.fetchData()
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const res = await MerchantService.detailDeviceLocation(this.$route.params.id)
          this.item = res.data
          const res1 = await MerchantService.historyDeviceLocation({
            serial: this.item.serial,
            page: 1,
            limit: 1000,
          })
          this.history = res1.data
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      viewDetailHistory(id) {
        this.showModalComponentMx('Chi tiết thay đổi', {
          name: DetailChange,
          props: {
            id,
            deviceTypeOptions: this.deviceTypeOptions,
            typeAppendixOptions: this.typeAppendixOptions,
            statusOptions: this.statusOptions,
          },
          id: '_detail_change',
          footerClass: 'd-none',
        })
      },
    },
  }
</script>
<style scoped>
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }
  .detail {
    cursor: pointer;
    color: blue;
  }
  .text-start {
    text-align: start;
    padding-left: 3px;
  }
  h6 {
    font-weight: 600;
    font-size: 14px;
  }
  .breadcrumb-area {
    display: flex;
    justify-content: space-between;
  }
</style>
